import { useEffect, useState } from "react";

function diff(target) {
  const now = new Date();
  let ms = target - now;
  if (ms < 0) ms = 0;
  const totalSeconds = Math.floor(ms / 1000);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return { days, hours, minutes, seconds, expired: ms === 0 };
}

const CELL =
  "flex flex-col items-center justify-center border border-white/10 bg-black/60 backdrop-blur-sm px-4 py-4 md:px-6 md:py-5 min-w-[70px] md:min-w-[90px]";

export default function Countdown({ targetDate, size = "md", className = "", testId }) {
  const target = new Date(targetDate);
  const [t, setT] = useState(() => diff(target));

  useEffect(() => {
    const id = setInterval(() => setT(diff(new Date(targetDate))), 1000);
    return () => clearInterval(id);
  }, [targetDate]);

  const numberCls =
    size === "lg"
      ? "font-heading text-4xl md:text-6xl leading-none text-white"
      : "font-heading text-3xl md:text-4xl leading-none text-white";
  const labelCls = "font-body text-[9px] md:text-[10px] uppercase tracking-[0.3em] text-white/50 mt-2";

  const units = [
    { v: t.days, l: "Giorni" },
    { v: t.hours, l: "Ore" },
    { v: t.minutes, l: "Min" },
    { v: t.seconds, l: "Sec" },
  ];

  return (
    <div data-testid={testId} className={`flex flex-wrap gap-2 md:gap-3 ${className}`}>
      {units.map((u, i) => (
        <div key={i} className={CELL}>
          <span className={numberCls}>{String(u.v).padStart(2, "0")}</span>
          <span className={labelCls}>{u.l}</span>
        </div>
      ))}
    </div>
  );
}
